"use strict";
exports.__esModule = true;
exports.SliceType = void 0;
var SliceType;
(function (SliceType) {
    SliceType["AnchorList"] = "anchor_list";
    SliceType["ArticleList"] = "article_list";
    SliceType["BannerCta"] = "banner_cta";
    SliceType["BulleTalk"] = "bulle_talk";
    SliceType["CardList"] = "card_list";
    SliceType["Cta"] = "cta";
    SliceType["Divider"] = "divider";
    SliceType["DownloadLinks"] = "download_links";
    SliceType["Exergue"] = "exergue";
    SliceType["Footnotes"] = "footnotes";
    SliceType["Grid"] = "grid";
    SliceType["Heading2"] = "heading_2";
    SliceType["Headnote"] = "headnote";
    SliceType["Hub"] = "hub";
    SliceType["Image"] = "image";
    SliceType["Insert"] = "insert";
    SliceType["Interview"] = "interview";
    SliceType["KeyNumbers"] = "key_numbers";
    SliceType["LargeCardGrid"] = "large_card_grid";
    SliceType["List"] = "list";
    SliceType["Podcast"] = "podcast";
    SliceType["PressReleaseList"] = "press_release_list";
    SliceType["Profile"] = "profile";
    SliceType["ProfileList"] = "profile_list";
    SliceType["PublicationList"] = "publication_list";
    SliceType["Quote"] = "quote";
    SliceType["RelatedArticles"] = "related_articles";
    SliceType["SizeableHeading2"] = "sizeable_heading_2";
    SliceType["SliderHero"] = "slider_hero";
    SliceType["Text"] = "text";
    SliceType["TextWithImage"] = "text_with_image";
    SliceType["TextWithProfile"] = "text_with_profile";
    SliceType["TextWithBulleTalk"] = "text_with_bulle_talk";
    SliceType["TileGrid"] = "tile_grid";
    SliceType["TwitterCarousel"] = "twitter_carousel";
    SliceType["Verbatim"] = "verbatim";
    SliceType["Video"] = "video";
    SliceType["VideoHero"] = "video_hero";
})(SliceType = exports.SliceType || (exports.SliceType = {}));
//# sourceMappingURL=slice-type.js.map